import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class PoepleSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      autoWidth: true,
      pagination: false,
      arrows: false,
      padding: `${115.5 / 375 * 100}vw`,
      type: 'loop',
      gap: `${50 / 375 * 100}vw`,
      rewind: true,
      loop: true,
      speed: 900,
      autoplay: true,
      interval: 3000,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          padding: 0,
          gap: `${60 / 1440 * 100}vw`,
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.dom.progress = this.slider.root.querySelector('.splide-carousel-progress-bar');
    // this.slider.on('mounted move', () => {
    //   const end  = this.slider.Components.Controller.getEnd() + 1;
    //   const rate = Math.min( ( this.slider.index + 1 ) / end, 1 );
    //   this.dom.progress.style.width = String( 100 * rate ) + '%';
    // } );
    this.slider.mount();
  }
}

export default PoepleSlides